import { render, staticRenderFns } from "./FormOffer.vue?vue&type=template&id=58a68eaf&"
import script from "./FormOffer.vue?vue&type=script&lang=js&"
export * from "./FormOffer.vue?vue&type=script&lang=js&"
import style0 from "./FormOffer.vue?vue&type=style&index=0&id=58a68eaf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports